// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:42:53

export default {
  "id": "valentine-s-day-couple-date",
  "slug": "valentine-s-day-couple-date",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/27ad571356914b3094dd021e7d0e8bf9-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/27ad571356914b3094dd021e7d0e8bf9/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Valentine's Day Couple Date",
      "description": "Experience the charm of Paris in Valentine's Day Couple Date, an amazing couple dress-up game for girls. Start with a picturesque breakfast and help Ellie glam up. Next, keep their fitness streak alive with a couple's workout as you dress them both in fashionable gym outfits and accessories. Later, style Ellie & Ben for a dreamy rooftop dinner. Choose from trendy clothing, accessories, and chic hairstyles to create the perfect romantic ambiance. Stay tuned for a special surprise from Ben.",
      "instructions": "Use your mouse to play this game on a desktop, or tap to play to mobile devices. ",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "couple",
        "date",
        "fashion",
        "holiday",
        "valentine"
      ]
    },
    "zh-CN": {
      "title": "情人节情侣约会",
      "description": "体验巴黎的浪漫魅力，在情人节情侣约会游戏中，一款令人惊叹的情侣装扮游戏。从一幅如画的早餐开始，帮助艾莉变得光彩照人。接着，保持他们的健身习惯，为他们穿上时尚的运动装和配饰。稍后，为艾莉和本装扮一场梦幻的屋顶晚餐。从潮流服饰、配饰和时尚发型中选择，打造完美的浪漫氛围。敬请期待本准备的特别惊喜。",
      "instructions": "使用鼠标在桌面电脑上玩游戏，或在移动设备上轻触屏幕进行游戏。",
      "genres": [
        "装扮"
      ],
      "tags": [
        "情侣",
        "约会",
        "时尚",
        "假日",
        "情人节"
      ]
    },
    "zh-TW": {
      "title": "情人節情人約會",
      "description": "體驗巴黎的魅力，在情人節約會中，一場令人驚艷的少女約會裝扮遊戲。從一幅風景絕佳的早餐開始，幫助艾莉變得光鮮亮麗。接著，透過為他們兩人穿上時尚的健身服裝和配飾，保持他們的健身紀錄。稍後，為艾莉和本打造一場夢幻的露營晚餐。從時尚服裝、配飾和時髦髮型中選擇，營造完美的浪漫氣氛。關注本為你準備的特別驚喜。",
      "instructions": "使用滑鼠在桌機上玩這款遊戲，或在行動裝置上點擊來遊玩。",
      "genres": [
        "装扮"
      ],
      "tags": [
        "夫妻",
        "約會",
        "時尚",
        "假日",
        "情人節"
      ]
    },
    "zh-HK": {
      "title": "情人節情侶約會",
      "description": "體驗巴黎的魅惑，在情人節情人約會遊戲中，一個令人驚艷的女子約會打扮遊戲。從一幅風景如畫的早餐開始，幫助艾莉魅力四射。接著，保持他們的運動紀錄，穿上時尚的健身服裝和配飾進行情人健身。稍後，為艾莉和本打扮一場夢幻的露台晚餐。從時尚服裝、配飾和時尚髮型中選擇，創造完美的羅曼蒂克氣氛。關注本將帶來的特別驚喜。",
      "instructions": "使用滑鼠於桌上型電腦遊玩此遊戲，或在移動裝置上按鍵遊玩。",
      "genres": [
        "裝扮"
      ],
      "tags": [
        "情侶",
        "約會",
        "時尚",
        "假期",
        "情人節"
      ]
    },
    "ja": {
      "title": "バレンタインデイカップルデート",
      "description": "バレンタインデイ・カップルデートでパリの魅力を体験しましょう。これは女子向けの素晴らしいカップルドレスアップゲームです。風景の美しい朝食から始め、エリーをグラマラスに仕立てましょう。次に、彼らのフィットネスの流れを続け、ファッションの gymアウトフィットとアクセサリーでふたりをドレスアップします。その後、エリーとベンをロッジングデートの為にスタイルを整えます。トレンディな服装、アクセサリー、シャキシャキなヘアスタイルから、完璧なロマンチックな雰囲気を作り出しましょう。ベンからの特別なサプライズにご期待ください。",
      "instructions": "デスクトップでこのゲームをプレイするにはマウスを使用してください、またはモバイルデバイスでタップしてプレイしてください。",
      "genres": [
        "ドレスアップ"
      ],
      "tags": [
        "カップル",
        "デート",
        "ファッション",
        "休暇",
        "バレンタイン"
      ]
    },
    "ko": {
      "title": "밸런타인데이 커플데이트",
      "description": "밸런타인데이 커플 데이트에서 파리의 매력을 경험해보세요. 여자아이들을 위한 놀라운 커플 드레스업 게임입니다. 아름다운 브렉퍼스트로 시작해 엘리를 고급스럽게 꾸며보세요. 다음으로, 커플 운동을 통해 그들의 건강 스티커를 유지하면서 두 사람을 패션 긴장 옷과 액세서리로 드레스하세요. 나중에는 엘리와 벤을 로맨틱한 스카이라프트 데이트로 스타일링하세요. 트렌디한 옷, 액세서리, 시크한 헤어스타일을 선택하여 완벽한 로맨틱한 분위기를 만들어보세요. 벤의 특별한 놀라움을 기다려주세요.",
      "instructions": "마우스를 사용하여 데스크톱에서 게임을 플레이하거나, 모바일 기기에서 탭하여 플레이하세요.",
      "genres": [
        "의상 변신"
      ],
      "tags": [
        "커플",
        "데이트",
        "패션",
        "휴가",
        "밸런타인"
      ]
    },
    "fr": {
      "title": "Rendez-vous en couple pour la Saint-Valentin",
      "description": "Profitez du charme de Paris dans \"Rendez-vous en amoureux le jour de l'Amour\", un incroyable jeu de déguisement pour couples. Commencez par un déjeuner pittoresque et aidez Ellie à briller. Ensuite, maintenez leur série de fitness avec un entraînement à deux, en les vêmant de tenues de gym fashionnables et d'accessoires. Plus tard, habillez Ellie et Ben pour un dîner de rêve sur le toit. Choisissez parmi des vêtements tendance, des accessoires et des coiffures chic pour créer l'ambiance romantique parfaite. Restez en éveil pour une surprise spéciale de la part de Ben.",
      "instructions": "Utilisez votre souris pour jouer à ce jeu sur un ordinateur de bureau, ou appuyez pour jouer sur des appareils mobiles.",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "couple",
        "date",
        "mode",
        "vacances",
        "Saint-Valentin"
      ]
    }
  }
};
